import React, { useState, useEffect } from 'react';
import BackButton from './BackButton';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebaseConfig'; // Adjust the import path as necessary

function Referral({ goBack, walletAddress }) {
  const [referralAddresses, setReferralAddresses] = useState([]);
  const [earnings, setEarnings] = useState(0);
  const [earningMessages, setEarningMessages] = useState(["Nothing earned yet"]);
  const referralLink = `https://test.kingdomofants.app/${walletAddress}`;

  
  useEffect(() => {
    const fetchReferrals = async () => {
      if(walletAddress) {
        const referrerDocRef = doc(db, "referrals", walletAddress);
        const referrerDocSnap = await getDoc(referrerDocRef);
  
        if (referrerDocSnap.exists()) {
          const referralsArray = referrerDocSnap.data().referrals || [];
          setReferralAddresses(referralsArray);
          checkReferralPurchases(referralsArray);
        } else {
          console.log("No referrals found or document does not exist.");
          setReferralAddresses([]);
        }
      }
    };

    fetchReferrals();
  }, [walletAddress]);

  const checkReferralPurchases = async (referralArray) => {
    let tempEarnings = 0;
    let messages = [];
    for (const address of referralArray) {
      const userDocRef = doc(db, "users", address);
      const userDocSnap = await getDoc(userDocRef);
      if (userDocSnap.exists() && userDocSnap.data().boughtAnt) {
        tempEarnings += 2; // Assuming $2 for each referral who bought an ant
        messages.push(`${address} $2 - BASIC ANT`);
      }
    }
    setEarnings(tempEarnings); // Update the earnings state with the calculated total
    setEarningMessages(messages.length > 0 ? messages : ["Nothing earned yet"]);
  };
  
    // Function to copy referral link to clipboard
    const copyToClipboard = (text) => {
      navigator.clipboard.writeText(text).then(() => {
        alert("Referral link copied to clipboard!"); // You can replace this with a more sophisticated notification
      }, (err) => {
        console.error('Error copying text to clipboard: ', err);
      });
    };

    const shareOnTwitter = () => {
        const tweetText = `Join Kingdom of Ants ${referralLink}`;
        const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}`;
        window.open(twitterUrl, '_blank');
      };

      return (
        <section id="nestwars">
          <div className="newui-container">
          <div className="platform-container" id="nestwars-platform">
            <div className="referral-container">
                <div className="ref-container">
                <div className="ref-s-container" id="invited"><h3>INVITEES</h3><h2>{referralAddresses.length}</h2></div>
                <div className="ref-s-container" id="earned"><h3>TOTAL EARNED</h3><h2>${earnings}</h2></div>
                <div className="ref-s-container" id="tobe"><h3>TO BE CLAIMED</h3><h2>$0</h2></div>
                </div>
                <div className="ref-container-2"><h2>YOUR REFERRAL LINK</h2>
                <div className="ref-b-container">
                    <div className="ref-link-cont"> 
                        <h3>{referralLink}</h3>
                        <FontAwesomeIcon icon={faCopy} onClick={() => copyToClipboard(referralLink)} />
                    </div>
                    <FontAwesomeIcon icon={faShareAlt} onClick={shareOnTwitter} />
                    <button className="ref-claim-cont">
                        CLAIM EARNED
                    </button>
                </div>
                </div>
                <div className="ref-container-3">
                    <div className="ref-container-4">
                    <div className="ref-container-4-h"><h2>Earnings</h2></div>
                    <div className="ref-container-4-b">
                    {earningMessages.map((message, index) => (
                    <p key={index}>{message}</p>
                ))}
                    </div>
                    </div>
                    <div className="ref-container-4">
                    <div className="ref-container-4-h"><h2>Referral List</h2></div>
                    <div className="ref-container-4-b">
                        {referralAddresses.length > 0 ? (
                            referralAddresses.map((address, index) => (
                                <p key={index}>{address}</p>
                            ))
                        ) : (
                            <p>No referrals yet.</p>
                        )}
                    </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </section>
    );
}

export default Referral;